import React from 'react';
import type { Config } from '../config';

export interface ConfigContextProps {
  config: Config;
}

export interface ConfigContext {
  config: Config;
}

export const ConfigContext = React.createContext<ConfigContext>(null as any);

export const ConfigContextProvider = (props: React.PropsWithChildren<ConfigContextProps>) => {
  return <ConfigContext.Provider value={props}>{props.children}</ConfigContext.Provider>;
};

export const useConfig = (): ConfigContext => {
  return React.useContext(ConfigContext);
};
